import React from 'react';
import QualificationLandingPage from "../../qualification_landing/QualificationLandingPage";
export function qualificationLandingPageRoutes() { return [{ path: '/qualification_landing_page', element: /*#__PURE__*/ React.createElement(QualificationLandingPage, null) }]; }
